import { Factory } from 'rosie';

Factory.define('FbPageAccountSecretContent');

Factory.define('FbPageAccountSecretContentWithDefaults')
  .extend('FbPageAccountSecretContent')
  .attr('authToken', 'some-auth-token');
